import { type Country } from '../../core/util/msisdn';
import Flag from '../Flag/Flag';
import './CountrySelector.css';
import { type DropDownOption } from '../DropDown/DropDownOptions';
import DropDown from '../DropDown/DropDown';
import Caret from '../common/caret.svg';
import { useLanguageContext } from '../../core/locale/LanguageContext';

interface CountrySelectorProps {
  onChangeCountry: (c: Country) => void;
  country: Country;
  countries: Country[];
  disabled?: boolean;
}

function CountrySelector({
  onChangeCountry,
  country,
  countries,
  disabled,
}: CountrySelectorProps): React.ReactNode {
  const languageContext = useLanguageContext();

  const options: DropDownOption[] = countries.map((country) => ({
    element: (
      <>
        <span className="caret"></span>
        <Flag country={country.country} />
        <span className="country-code">+{country.countryCode}</span>
        <span className="country-name">{country.name(languageContext.countryLocalization)}</span>
      </>
    ),
    id: country.countryCode,
    className: 'phone-input phone-input-entry',
    ariaLabel: `${country.name(languageContext.countryLocalization)} +${country.countryCode}`,
    onClick: () => onChangeCountry(country),
    name: country.name(languageContext.countryLocalization),
  }));
  return (
    <>
      <DropDown
        options={options}
        disabled={disabled}
        selector={
          <>
            {!disabled && <img alt="caret" src={Caret} aria-hidden="true" className="caret" />}
            <Flag country={country.country} />
            <span
              className="country-code"
              id="phoneNumber-country-code"
              aria-label={`${languageContext.getLocalizedText('inputCountryCodeLabel')} +${
                country.countryCode
              }`}
            >
              +{country.countryCode}
            </span>
          </>
        }
        optionsClassName="phone-picker"
        selectorId="country-selector"
        selectedId={country.countryCode}
        ariaLabel={languageContext.getLocalizedText(
          'countryCodeSelectorLabel',
          country.name(languageContext.countryLocalization)
        )}
      />
    </>
  );
}

export default CountrySelector;
